import { useEffect } from "react";

interface SEOProps {
  title: string;
  description?: string;
}

/**
 * Reusable SEO component for dynamic head tag updates on route changes.
 * Avoids layout shifting and updates document title and meta description.
 */
export default function SEO({ title, description }: SEOProps) {
  useEffect(() => {
    // 1. Update Title
    const defaultTitle = "ADHD-AID Psychiatry | Online ADHD Testing & Medication";
    document.title = title ? `${title} | ADHD-AID` : defaultTitle;

    // 2. Update Description Meta Tag
    if (description) {
      // Main description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute("content", description);
      } else {
        metaDescription = document.createElement("meta");
        metaDescription.setAttribute("name", "description");
        metaDescription.setAttribute("content", description);
        document.head.appendChild(metaDescription);
      }

      // Open Graph Description
      const ogDescription = document.querySelector('meta[property="og:description"]');
      if (ogDescription) {
        ogDescription.setAttribute("content", description);
      }

      // Twitter Description
      const twitterDescription = document.querySelector('meta[property="twitter:description"]');
      if (twitterDescription) {
        twitterDescription.setAttribute("content", description);
      }
    }

    // 3. Update OG and Twitter Titles to match the page title
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute("content", title ? `${title} | ADHD-AID` : defaultTitle);
    }
    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute("content", title ? `${title} | ADHD-AID` : defaultTitle);
    }
  }, [title, description]);

  return null;
}
